import { useState } from 'react';
import { Input, InputGroup, Icon } from '@chakra-ui/react';
import { HiOutlineEye, HiOutlineEyeOff } from 'react-icons/hi';

const PasswordInput = ({ value, onChange, placeholder = '••••••••', ...rest }) => {
    const [show, setShow] = useState(false);

    const toggle = (
        <Icon
            fontSize={20}
            color="text.grey"
            cursor="pointer"
            onClick={() => setShow(s => !s)}
            _hover={{ color: 'gray.900' }}
        >
            {show ? <HiOutlineEyeOff /> : <HiOutlineEye />}
        </Icon>
    );

    return (
        <InputGroup endElement={toggle}>
            <Input
                variant="primary"
                type={show ? 'text' : 'password'}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                {...rest}
            />
        </InputGroup>
    );
};

export default PasswordInput;
